/**
 * @preserve
 * jQuery Scroll To Anchor - v1.0.0
 * Copyright (c) 2014 Karsten Müller
 */

/**
 * jQuery Plugin which adds a scrolling animation for links which point to a internal target location
 * within the current document (URL fragment, which is preceded by a hash mark (#)).
 */

(function ( $ ){

	var defaults = {
		speed: 3000, // Pixel pro Sekunde
		duration_min: 200 // Millisekunden
	};

	$.fn.scrollToAnchor = function(options){

		var options = options || {};

		return this.each(function(){

			var kontext = $(this);

			if ($("a[href*=#]", kontext).length !== 0){

				var settings = $.extend({}, defaults);

				$("a[href*=#]", kontext).each(function(e){

					var id = $(this).attr("href").replace(/.*#/, "");

					$(this).click(function(e){

						e.preventDefault();

						if ($("#" + id).length !== 0){
							var top = $("#" + id).offset().top;
						} else {
							var top = 0;
						}

						var distanz = Math.abs($(window).scrollTop() - top);

						var dauer = distanz/settings.speed * 1000;

						dauer = dauer < settings.duration_min ? settings.duration_min : dauer;

						$("html, body").animate(
							{ scrollTop: top },
							dauer,
							function(){
								location.hash = id;
							}
						);

					});

				});

			}

		});

	}

}( jQuery ));